export const defaultTextPlaceHolder = '@default@';
export const urlSubmitString = '_submit_id';
export const jsbTypeString = '_jsb_type';
export const prefillDataString = '_prefill_data';
